// extracted by mini-css-extract-plugin
export default {"bold":"PromotionTypeRow__bold-JFL5L","assets":"PromotionTypeRow__assets-iD_6p","count":"PromotionTypeRow__count-zJsnh","menu":"PromotionTypeRow__menu-O0oxM"};